import { jsxs as e, jsx as o } from "react/jsx-runtime";
const C = ({
  width: r,
  height: t,
  className: n
}) => /* @__PURE__ */ e(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 18 18",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6.16814 13V4.42H9.13214C11.2201 4.42 12.4081 5.344 12.4081 7.156V7.204C12.4081 9.016 11.1481 9.88 9.19214 9.88H8.10014V13H6.16814ZM8.10014 8.524H9.08414C10.0321 8.524 10.5361 8.068 10.5361 7.216V7.168C10.5361 6.256 10.0081 5.896 9.08414 5.896H8.10014V8.524Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6.49935 17.3337H11.4993C15.666 17.3337 17.3327 15.667 17.3327 11.5003V6.50033C17.3327 2.33366 15.666 0.666992 11.4993 0.666992H6.49935C2.33268 0.666992 0.666016 2.33366 0.666016 6.50033V11.5003C0.666016 15.667 2.33268 17.3337 6.49935 17.3337Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      )
    ]
  }
);
export {
  C as Content
};
